import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function TariffsLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
